
        Component.define('video-home', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el = $(el);
const $video = $el.find('.video video');
const $btnScroll = $el.find('.btn-sroll');
const $goToScroll = $('#home-sobre');
const $btnUnmute = $el.find('.btn-unmute');

$btnScroll.on('click', function(){
    Navigation.helpers.scrollTo($goToScroll);
});

$btnUnmute.on('click', function(){
    if( $video.prop('muted') ) {
        $video.prop('muted', false);
        $(this).addClass('sound-active');
    } else {
        $video.prop('muted', true);
        $(this).removeClass('sound-active');
    }
});
        });